import { PromiseClient } from 'hub-http/adapters/promiseClient';
import { ObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import Raven from 'raven-js';
import { trackRequest } from '../metrics/requestMetrics';

type FetchDecryptedHighlySensitivePropertyValueParams = {
  objectId: string;
  objectTypeId: ObjectTypeId;
  propertyName: string;
  timestamp?: number;
  httpClient: PromiseClient;
};

export const fetchDecryptedHighlySensitivePropertyValue = ({
  objectTypeId,
  objectId,
  propertyName,
  timestamp,
  httpClient,
}: FetchDecryptedHighlySensitivePropertyValueParams) => {
  const request = trackRequest('fetchdecryptedhighlysensitivepropertyvalue');
  return httpClient
    .get<{ value: string }>(
      `inbounddb-objects-sensitive/v1/decrypted/${encodeURIComponent(
        objectTypeId
      )}/${encodeURIComponent(objectId)}/${encodeURIComponent(propertyName)}`,
      timestamp
        ? {
            query: { timestamp },
          }
        : {}
    )
    .then((response) => {
      request.success();
      if (!response) {
        return '';
      }
      return response.value || '';
    })
    .catch((err) => {
      request.failure(err);
      Raven.captureException(err, {
        extra: {
          apiError: 'DECRYPT_HIGHLY_SENSITIVE_PROPERTY_VALUE_FAILED',
          objectId,
          objectTypeId,
          propertyName,
        },
      });
      throw err;
    });
};
